export function isShown(modes, hideModes, value) {
  if (value === "insurance") {
    return hideModes === undefined || !hideModes.includes(value);
  }
  if (value === "stayLodging") {
    return hideModes === undefined || !hideModes.includes(value);
  }
  return (modes === undefined || modes.includes(value)) && (hideModes === undefined || !hideModes.includes(value));
}
export function getQueryStringValue(key) {
  const regexp = new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i");
  return decodeURIComponent(window.location.search.replace(regexp, "$1"));
}
export function createGMTDate(fromDate) {
  const date = fromDate ? new Date(fromDate) : new Date();
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  date.setHours(0);
  const newDay = date.getDate();
  const newMonth = date.getMonth();
  const newYear = date.getFullYear();
  if (date.getTimezoneOffset() < 0 && (newDay < day || newMonth < month || newYear < year)) {
    date.setDate(date.getDate() + 1);
  }
  return date;
}
const STAY_DATES = "stay";
export function deserializeDates(dates) {
  const from = createGMTDate(dates.from);
  const to = createGMTDate(dates.to);
  return {
    from,
    to
  };
}
export function readStayDates() {
  const stored = window.sessionStorage.getItem(STAY_DATES);
  if (!stored) return null;
  const parsed = JSON.parse(stored);
  return deserializeDates(parsed);
}
export const formatPrice = (intl, price, options = {}, freeLabel) => {
  if (price === undefined) return;
  if (price === 0 && freeLabel) return freeLabel;
  return intl.formatNumber(price, {
    style: "currency",
    currency: "EUR",
    ...options
  });
};
export function partition(array, filter) {
  let pass = [],
    fail = [];
  if (array !== undefined) array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
  return [pass, fail];
}
function round(value, decimals = 2) {
  return Math.round(value * 10 ** decimals) / 10 ** decimals;
}
function roundDiff(a, b) {
  return (Math.round(a * 100) - Math.round(b * 100)) / 100;
}
export function computePercentage(price, publicPrice) {
  if (publicPrice === 0 || price === 0 || !publicPrice) return undefined;
  const reduction = roundDiff(publicPrice, price) / publicPrice * 100;
  const percentage = Math.floor(reduction * 10) / 10;
  return percentage > 0.1 ? percentage : undefined;
}